var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-store"},[_c('HeaderB',{attrs:{"screen":_vm.view}}),_vm._v(" "),_c('div',{staticClass:"contents"},[_vm._t("default",function(){return [_c('router-view',{ref:"child1",attrs:{"screen":_vm.view}})]},{"data":_vm.view})],2),_vm._v(" "),_c('FooterB')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202b64e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeLay/HomeLay.vue
// module id = null
// module chunks = 